import "./Contact.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <FraternalExcellenceHeader />
      <GetInTouch />
      <Footer />
    </div>;
}